import { render, staticRenderFns } from "./LuxuryCar.vue?vue&type=template&id=490d9c20"
import script from "./LuxuryCar.vue?vue&type=script&lang=js"
export * from "./LuxuryCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports